export default __webpack_public_path__ + "static/media/Facebook.874c343f.svg";